module.exports = __webpack_public_path__ + "media/images/profile_big-afe0ea288be2c4202e29a4504a4de544.jpg";